jQuery(document).ready(function ($) {
    // Preloader - Start
// --------------------------------------------------
    $('#preloader').fadeOut('slow',function(){$(this).remove();});

    $('.custom-backdrop').on('backdropClassChange', function() {
        if($(this).hasClass("show")){
            $('body').css({ 'padding-right' : '0px', 'overflow' : 'hidden' });
        }else{
            $('body').css({ 'padding-right' : '', 'overflow' : '' });
        }
    });

    // Back To Top - Start
    // --------------------------------------------------
    $(window).scroll(function () {
        resizeMainMenuTop();
        if ($(this).scrollTop() > 200) {
            $('.backtotop:hidden').stop(true, true).fadeIn();
            $('.imessage:hidden').stop(true, true).fadeIn();
        } else {
            $('.backtotop').stop(true, true).fadeOut();
            $('.imessage').stop(true, true).fadeOut();
        }
    });
    $(function () {
        $(".scroll").on('click', function () {
            $("html,body").animate({scrollTop: 0}, "fast");
            return false
        });
    });
    // Back To Top - End
    // --------------------------------------------------
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });
    //menu collapse
    $('#main_menu_dropdown').on('show.bs.collapse', function () {
        resizeMainMenuTop();
        $('.custom-backdrop').addClass("show").trigger('backdropClassChange');
        $('.sticky-icons-container, .imessage , .backtotop').hide();
    })

    $('#main_menu_dropdown').on('hide.bs.collapse', function () {
        $('.sticky-icons-container, .imessage, .backtotop').show();
    })

    function resizeMainMenuTop(){
        if ($(this).scrollTop() < 40)
            $('#main_menu_dropdown').css("top",159  - (parseInt($(".header_top").height()) < 80 ? 20 : 0));
        else
            $('#main_menu_dropdown').css("top",80);
    }
    // Search - Start
    // --------------------------------------------------

        function hideSearchBody(){
            if($(".search_body").is(":visible"))
             $('.custom-backdrop').removeClass("show").trigger('backdropClassChange');
            $(".search_body").slideUp();
        }
        $('.search_close').on('click', function () {
            hideSearchBody();
        });
        $('.search_btn').on('click', function () {
            $('.search_body').slideDown();
            $('.custom-backdrop').addClass("show").trigger('backdropClassChange');
        });

        $(document).mouseup(function(e)
        {
            let container = $(".search_body");
                if (!container.is(e.target) && container.has(e.target).length === 0)
                    hideSearchBody()

            let main_menu_inner = $(".main_menu_inner.navbar-collapse.collapse.show");
            if (!main_menu_inner.is(e.target) && main_menu_inner.has(e.target).length === 0) {
                if(main_menu_inner.hasClass("show"))
                $('.custom-backdrop').removeClass("show").trigger('backdropClassChange');
                main_menu_inner.collapse('hide');
            }
        });

    // Search - End
    // --------------------------------------------------

    // sticky header - start
    // --------------------------------------------------
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 120) {
            $('.header_section').addClass("sticky")
        } else {
            $('.header_section').removeClass("sticky")
        }
    });
    // sticky header - end
    // --------------------------------------------------

    // Select Option - Start
    // --------------------------------------------------
    $('.nice-select').niceSelect();


    // Select Option - End
    // --------------------------------------------------


    // Common Carousels - Start
    // --------------------------------------------------
    $('.common_carousel_3col').slick({
        dots: true,
        speed: 1000,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        pauseOnHover: true,
        autoplaySpeed: 5000,
        prevArrow: ".cc3c_left_arrow",
        nextArrow: ".cc3c_right_arrow",
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    // Common Carousels - End
    // --------------------------------------------------

    $(".sticky-icons li").on("click", function(){
        window.open($(this).data("link"));
    });

    // About Offcanvas - Start
    // --------------------------------------------------
        $('.about_close_btn, .about_sidebar_overlay').on('click', function () {
            $('.about_sidebar').removeClass('active');
            $('.about_sidebar_overlay').removeClass('active');
        });

        $('.offcanvas_btn').on('click', function () {
            $('.about_sidebar').addClass('active');
            $('.about_sidebar_overlay').addClass('active');
        });

});
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})
